<template>
  <NuxtLayout>
    <HeroHeader stacked-elements :title-visible="false" :image="page.gallery_images?.[0] || null" class="resort__HeroHeader">
      <div class="container heroHeader__StackedElementsContent">
        <div>
          <div class="resort__HeaderLocationWrapper">
            <Icon name="location" />
            <span v-text="page.place?.title || ''" />
          </div>
          <h1 v-text="page.name" />
        </div>

        <div class="resort__HeaderRightSide">
          <div v-if="page.overlay_image" class="accommodationDetail__HeaderOverlayImage">
            <Flare :srcset="page.overlay_image" width="400" :alt="page.overlay_image" />
          </div>

          <button v-if="page.gallery_images?.length" :aria-label="$t('seeGallery')" @click="open('gallery')" class="resort__GalleryButton">
            <Icon name="photo-gallery" />
          </button>

          <nuxt-link v-if="page?.camp_map?.sef" :to="page.camp_map.sef" class="resort__GalleryButton">
            <img src="/resources/images/icons/map.svg" alt="Map" width="24" height="24" />
          </nuxt-link>
        </div>
      </div>
    </HeroHeader>

    <CMSField v-if="page?.content" :data="page.content" />

    <section v-if="accommodationsList?.length" class="resort__AccommodationsList container--Medium">
      <p v-text="$t('propertiesAvailable', accommodationsList.length)" class="resort__AccommodationsListCounter" />
      <PropertyItem v-for="item in accommodationsList" :key="item.id" :property="item" :short-name="true" />
    </section>
    
    <Modal v-show="dialogs.gallery" v-model="dialogs.gallery" class="modal__Gallery">
      <template v-for="item in page.gallery_images" :key="item.image?.id || item.id">
        <FlarePicture v-if="item"
          :src="{
            1920: { src: item.image || item, width: 1000 },
          }"
          :style="`color: ${getDominantColor(item.image || item)}`"
          :alt="item.image?.alt || item.alt"
        />
        <p v-if="item.description" v-text="item.description" />
      </template>
    </Modal>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  const props = defineProps({
    page: {}
  });

  useHead({
    htmlAttrs: {
      class: 'transparentHeader fixedHeader fixedHeader--WithoutTopPadding',
    }
  })
  const { accommodationsData } = useSetup();

  const dialogs = reactive({
    gallery: false
  });
  const { open } = useModal(dialogs);

  const accommodationsList = computed(() => {
    if (!props.page.resort_accommodations_list?.length) return [];
    let list = [];
    for (const item of props.page.resort_accommodations_list) {
      const accommodation = accommodationsData.value[item.id];
      if (accommodation) {
        list.push(accommodation);
      }
    }
    return list;
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_resort.scss');
</style>